module.exports = __webpack_public_path__ + "static/media/ye.1e7c106a.svg";